module.exports = require("./ff-Latn-GN.js");